import { useSiteQuery as hook } from './generated';

export function useSiteQuery(siteId: string, pause?:boolean) {
  const [result, reexecuteQuery] = hook({ pause: pause || !siteId, variables: { siteId } });
  const site = result.data?.site;

  return { site, result, reexecuteQuery, loading:result.fetching, siteId };
}
